import { render, staticRenderFns } from "./ArrowBack.vue?vue&type=template&id=07c8f04c&scoped=true&"
import script from "./ArrowBack.vue?vue&type=script&lang=js&"
export * from "./ArrowBack.vue?vue&type=script&lang=js&"
import style0 from "./ArrowBack.vue?vue&type=style&index=0&id=07c8f04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c8f04c",
  null
  
)

export default component.exports